import localforage from 'localforage';

export default defineNuxtPlugin(() => {
  let store: LocalForage;
  if (import.meta.client) {
    localforage.config({
      driver: localforage.INDEXEDDB,
      name: 'kegelstorage',
      version: 1.0,
      size: 4980736, // Size of database, in bytes.
      storeName: 'kegelstorage', // Should be alphanumeric, with underscores.
      description: 'some description',
    });
    store = localforage.createInstance({
      name: 'kegelstorage',
    });
  }

  async function getItem(itemName: string): Promise<any> {
    if (import.meta.client) {
      try {
        return await store?.getItem(itemName);
      }
      catch (error: unknown) {
        console.error('INDEXED DB GET ITEM ERROR', error);
      }
    }
  }

  return {
    provide: {
      db: {
        getItem,
        setItem(itemName: string, value: any): void {
          if (import.meta.client) {
            try {
              store?.setItem(itemName, value);
            }
            catch (error: unknown) {
              console.error('INDEXED DB SET ITEM ERROR', error);
            }
          }
        },
      },
    },
  };
});
